module.exports = __webpack_public_path__ + "media/images/user/lp/solution/mobile-f2197c624998a1ecd6e8b772d81e5a4c.png";